// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__3fvuH","boxCategory":"styles_boxCategory__1uTtP","imgBox":"styles_imgBox__3i1zf","textBox":"styles_textBox__1jLDh","Boxtext":"styles_Boxtext__2NQRp"};